import styled from "@emotion/styled"
import { spacingStaticXs, spacingStaticMd, spacingFluidSm } from "@porsche-design-system/components-react/emotion"
import { Grid, GridItem, Skeleton } from "src/components"
import { contentGridSize, imageGridSize } from "./gridSizes.const"

export const VinSearchResultSkeleton = () => (
	<>
		<ResultMessageWrapper>
			<Skeleton.Text $width="50%" />
		</ResultMessageWrapper>
		<Grid $rowGap={spacingFluidSm}>
			<GridItem size={imageGridSize}>
				<Skeleton.Picture />
			</GridItem>
			<GridItem size={contentGridSize}>
				<Skeleton.List withHeader entries={5} />
			</GridItem>
		</Grid>
	</>
)

const ResultMessageWrapper = styled.div`
	margin: ${spacingStaticXs} 0 ${spacingStaticMd};
`
